/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import toast from "react-hot-toast";

export default function Bildirimlerim() {
    const [bildirimler, setBildirimler] = useState([]);
    const [yukleniyor,  setYukleniyor]  = useState(true);
    const [filtre,      setFiltre]      = useState("hepsi"); // hepsi | okunmamis | okunmus

    const yukle = async () => {
        setYukleniyor(true);
        try {
            const { data, error } = await supabase
                .from("notifications")
                .select("*, alerts(sembol, piyasa, para_birimi, hedef_fiyat)")
                .order("created_at", { ascending: false });
            if (error) throw error;
            setBildirimler(data || []);
        } catch (e) {
            toast.error("Bildirimler yüklenemedi: " + e.message);
        } finally {
            setYukleniyor(false);
        }
    };

    useEffect(() => { yukle(); }, []);

    const okunduIsaretle = async (id) => {
        try {
            const { error } = await supabase
                .from("notifications")
                .update({ okundu: true })
                .eq("id", id);
            if (error) throw error;
            setBildirimler(prev => prev.map(b => b.id === id ? { ...b, okundu: true } : b));
        } catch (e) {
            toast.error(e.message);
        }
    };

    const tumunuOku = async () => {
        try {
            const { error } = await supabase
                .from("notifications")
                .update({ okundu: true })
                .eq("okundu", false);
            if (error) throw error;
            setBildirimler(prev => prev.map(b => ({ ...b, okundu: true })));
            toast.success("Tümü okundu olarak işaretlendi");
        } catch (e) {
            toast.error(e.message);
        }
    };

    const sil = async (id) => {
        try {
            const { error } = await supabase.from("notifications").delete().eq("id", id);
            if (error) throw error;
            setBildirimler(prev => prev.filter(b => b.id !== id));
        } catch (e) {
            toast.error(e.message);
        }
    };

    const tumunuSil = async () => {
        if (!window.confirm("Tüm bildirimleri silmek istediğinize emin misiniz?")) return;
        try {
            const { error } = await supabase
                .from("notifications")
                .delete()
                .in("id", bildirimler.map(b => b.id));
            if (error) throw error;
            setBildirimler([]);
            toast.success("Tüm bildirimler silindi");
        } catch (e) {
            toast.error(e.message);
        }
    };

    const gosterilen = bildirimler.filter(b =>
        filtre === "hepsi"      ? true :
        filtre === "okunmamis"  ? !b.okundu :
        b.okundu
    );

    const okunmamisSayi = bildirimler.filter(b => !b.okundu).length;

    const tarihFormat = (t) => {
        if (!t) return "—";
        const d = new Date(t);
        const simdi = new Date();
        const fark  = Math.floor((simdi - d) / 1000);
        if (fark < 60)   return "Az önce";
        if (fark < 3600) return `${Math.floor(fark / 60)} dk önce`;
        if (fark < 86400)return `${Math.floor(fark / 3600)} sa önce`;
        return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    };

    if (yukleniyor) return (
        <div style={{ padding: "2rem", color: "#6b7280" }}>⏳ Yükleniyor...</div>
    );

    return (
        <div style={s.sayfa}>
            <div style={s.header}>
                <div>
                    <h2 style={s.baslik}>
                        🔔 Bildirimlerim
                        {okunmamisSayi > 0 && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", borderRadius: "99px",
                                fontSize: "12px", fontWeight: "700", background: "#fee2e2", color: "#dc2626" }}>
                                {okunmamisSayi} yeni
                            </span>
                        )}
                    </h2>
                    <p style={s.altBaslik}>Fiyat alarmı bildirimleriniz</p>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                    {["hepsi", "okunmamis", "okunmus"].map(f => (
                        <button key={f} onClick={() => setFiltre(f)}
                            style={{ ...s.filtreBtn, background: filtre === f ? "#1e3a5f" : "white",
                                color: filtre === f ? "white" : "#374151" }}>
                            {f === "hepsi" ? "Hepsi" : f === "okunmamis" ? "🔴 Okunmamış" : "✅ Okunmuş"}
                        </button>
                    ))}
                    {okunmamisSayi > 0 && (
                        <button onClick={tumunuOku}
                            style={{ ...s.filtreBtn, background: "#f0fdf4", color: "#16a34a",
                                border: "1px solid #bbf7d0" }}>
                            ✅ Tümünü Oku
                        </button>
                    )}
                    {bildirimler.length > 0 && (
                        <button onClick={tumunuSil}
                            style={{ ...s.filtreBtn, background: "#fff1f2", color: "#dc2626",
                                border: "1px solid #fca5a5" }}>
                            🗑️ Tümünü Sil
                        </button>
                    )}
                </div>
            </div>

            {gosterilen.length === 0 ? (
                <div style={s.bos}>
                    <div style={{ fontSize: "48px", marginBottom: "1rem" }}>🔔</div>
                    <div style={{ fontWeight: "600", color: "#374151" }}>
                        {filtre === "okunmamis" ? "Okunmamış bildirim yok" :
                         filtre === "okunmus"   ? "Okunmuş bildirim yok" :
                         "Henüz bildirim yok"}
                    </div>
                    <div style={{ color: "#9ca3af", fontSize: "13px", marginTop: "4px" }}>
                        Fiyat alarmları tetiklendiğinde buraya bildirim gelecek
                    </div>
                </div>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {gosterilen.map(b => (
                        <div key={b.id} style={{
                            ...s.bildirimKart,
                            borderLeft: `4px solid ${b.okundu ? "#e5e7eb" : "#2563eb"}`,
                            background:  b.okundu ? "white" : "#eff6ff",
                        }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                                        {!b.okundu && (
                                            <span style={{ width: "8px", height: "8px", borderRadius: "50%",
                                                background: "#2563eb", display: "inline-block", flexShrink: 0 }} />
                                        )}
                                        <span style={{ fontWeight: "700", fontSize: "14px", color: "#1e3a5f" }}>
                                            {b.baslik}
                                        </span>
                                    </div>
                                    <p style={{ margin: "0 0 8px", fontSize: "13px", color: "#374151", lineHeight: "1.5" }}>
                                        {b.mesaj}
                                    </p>
                                    {b.alerts && (
                                        <div style={{ display: "flex", gap: "12px", fontSize: "11px", color: "#6b7280" }}>
                                            <span>📊 {b.alerts.piyasa}</span>
                                            <span>💱 {b.alerts.para_birimi}</span>
                                            <span>🎯 Hedef: <strong style={{ color: "#16a34a" }}>{b.alerts.hedef_fiyat}</strong></span>
                                        </div>
                                    )}
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end",
                                    gap: "8px", marginLeft: "1rem", flexShrink: 0 }}>
                                    <span style={{ fontSize: "11px", color: "#9ca3af", whiteSpace: "nowrap" }}>
                                        {tarihFormat(b.created_at)}
                                    </span>
                                    <div style={{ display: "flex", gap: "4px" }}>
                                        {!b.okundu && (
                                            <button onClick={() => okunduIsaretle(b.id)}
                                                style={s.akBtn} title="Okundu işaretle">✅</button>
                                        )}
                                        <button onClick={() => sil(b.id)}
                                            style={{ ...s.akBtn, color: "#ef4444" }} title="Sil">🗑️</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const s = {
    sayfa:        { padding: "1.5rem" },
    header:       { display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                    marginBottom: "1.5rem", flexWrap: "wrap", gap: "1rem" },
    baslik:       { margin: 0, fontSize: "20px", display: "flex", alignItems: "center" },
    altBaslik:    { color: "#6b7280", fontSize: "13px", margin: "4px 0 0" },
    filtreBtn:    { padding: "5px 14px", borderRadius: "8px", border: "1px solid #e5e7eb",
                    cursor: "pointer", fontSize: "12px", fontWeight: "600" },
    bos:          { textAlign: "center", padding: "4rem", color: "#9ca3af",
                    background: "white", borderRadius: "12px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
    bildirimKart: { padding: "1rem 1.25rem", borderRadius: "10px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.06)", transition: "all 0.2s" },
    akBtn:        { background: "none", border: "none", cursor: "pointer",
                    fontSize: "14px", padding: "2px 4px", borderRadius: "4px" },
};
